import * as z from 'zod';
import { usStateOrTerritorySchema } from '../../enums.mjs';
import { ProductType } from '../opaque.mjs';

const agencyLicensedForSchema = z.record(usStateOrTerritorySchema, z.enum(ProductType).array());

export { agencyLicensedForSchema };
